import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import BankInformationNew from "./BankInformationNew";
import BankInformationPre from "./BankInformationPre";
import BankInformationPostAndRePledge from "./BankInformationPostAndRePledge";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";
import { apiHandler } from "assets/api"; // or your own loader
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import { parseAndSetFlag } from "utils/Utils";
import ToastModal from "views/components/ToastModal";

const BankInformation = ({
  setNext,
  setBack,
  loanApplicationId,
  editable,
  status,
  classes,
  subStatus,
  loanType,
  crossSell,
  mobileNum,
  featureFlags,
  existingLoanData,
}) => {
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [ornamentDetail, setOrnamentDetails] = useState({});
  const [applicantDetails, setApplicantDetails] = useState({});
  const [yearlyCashValue, setYearlyCashValue] = useState("");
  const [detailsFullFiled, setDetailsFullField] = useState(true);
  const outletData = featureFlags;
  const financialYearCashValidationFlag = parseAndSetFlag(
    outletData?.financialYearCashValidationFlag
  );
  const enabledV2InprocessTab = parseAndSetFlag(
    outletData?.enabledV2InprocessTab
  );
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  useEffect(() => {
    if(editable && !enabledV2InprocessTab){
      GetLoanApplicantDetails();
    }
  }, [editable, enabledV2InprocessTab]);

  const GetLoanOrnamentDetails = async () => {
    const result = await apiHandler({
      url: endpoint.ORNAMENT_GETDATA + loanApplicationId,
      authToken: authToken,
    });
    if (!result?.data?.error_code) {
      setDetailsFullField(true);
      setOrnamentDetails(result?.data);
      GetCashDetails();
    } else {
      setCallInProgress(false);
      setDetailsFullField(true);
      toastUpdate("Error", result?.data?.user_description, true);
    }
  };

  const GetLoanApplicantDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.APPLICANT_GETDATA + loanApplicationId,
      authToken: authToken,
    });
    if (!result?.data?.error_code) {
      setDetailsFullField(true);
      setApplicantDetails(result?.data);
      if (subStatus !== "PRE_PLEDGE") {
        GetLoanOrnamentDetails();
      } else {
        GetCashDetails();
      }
    } else {
      setDetailsFullField(false);
      setCallInProgress(false);
      toastUpdate("Error", result?.data?.user_description, true);
    }
  };

  const GetCashDetails = async () => {
    const result = await apiHandler({
      url: endpoint.SEARCH_PROFILE + mobileNum?.trim(),
      method: "GET",
      authToken: authToken,
    });
    if (
      result?.data?.length > 0 &&
      financialYearCashValidationFlag &&
      !result?.data?.error_code
    ) {
      const result1 = await apiHandler({
        url:
          endpoint.GET_CASH_DETAILS_IN_YEAR +
          result?.data?.[0]?.customerId +
          "?payInOrPayOut=PAYOUT",
        authToken: authToken,
      });
      setCallInProgress(false);
      if (result1?.data?.error_code) {
        setYearlyCashValue(0);
      } else {
        setYearlyCashValue(Number(result1?.data?.remainingBalance));
      }
    } else {
      setCallInProgress(false);
      setYearlyCashValue(Number(outletData?.cashThreshHoldFlag));
    }
  };

  let ComponentToRender;

  if (subStatus === "POST_PLEDGE" || loanType === "RE_PLEDGE") {
    ComponentToRender = (
      <BankInformationPostAndRePledge
        classes={classes}
        status={status}
        loanApplicationId={loanApplicationId}
        setNext={setNext}
        setBack={setBack}
        editable={editable}
        crossSell={crossSell}
        ornamentDetail={ornamentDetail}
        applicantDetails={applicantDetails}
        mobileNum={mobileNum}
        yearlyCashValue={yearlyCashValue}
        financialYearCashValidationFlag={financialYearCashValidationFlag}
        detailsFullFiled={detailsFullFiled}
        featureFlags={featureFlags}
        existingLoanData={existingLoanData}
      />
    );
  } else if (subStatus === "PRE_PLEDGE") {
    ComponentToRender = (
      <BankInformationPre
        classes={classes}
        status={status}
        loanApplicationId={loanApplicationId}
        setNext={setNext}
        setBack={setBack}
        editable={editable}
        ornamentDetail={ornamentDetail}
        applicantDetails={applicantDetails}
        mobileNum={mobileNum}
        yearlyCashValue={yearlyCashValue}
        financialYearCashValidationFlag={financialYearCashValidationFlag}
        detailsFullFiled={detailsFullFiled}
        featureFlags={featureFlags}
      />
    );
  } else {
    ComponentToRender = (
      <BankInformationNew
        classes={classes}
        status={status}
        loanApplicationId={loanApplicationId}
        setNext={setNext}
        setBack={setBack}
        editable={editable}
        crossSell={crossSell}
        ornamentDetail={ornamentDetail}
        applicantDetails={applicantDetails}
        mobileNum={mobileNum}
        yearlyCashValue={yearlyCashValue}
        financialYearCashValidationFlag={financialYearCashValidationFlag}
        detailsFullFiled={detailsFullFiled}
        featureFlags={featureFlags}
      />
    );
  }

  return (
    <>
      {!callInProgress && ComponentToRender}
      {callInProgress && (
        <div style={{ textAlign: "center", marginTop: 20 }}>
          <CircularProgresss callInProgress={callInProgress} />
        </div>
      )}
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
    </>
  );
};

BankInformation.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
  editable: PropTypes.object,
};

export default BankInformation;
